<template>
  <div class="bottom">
    <div class="w_1300">
      <div class="ifoot_b">
        <div class="ifoot_top">
        <div class="ifewm">
          <img src="../assets/img/toplogo_jiegui.png">
        </div>
        <div class="iftext">
          <p class="inp2">联系电话：021-54651536（王老师）</p>
          <p class="inp5">地址：上海市徐汇区古美路1658号6B幢2层208室</p>
          <p class="inp8"><a href="https://beian.miit.gov.cn/" target="_blank">ICP备：沪ICP备2021029742号-1</a></p>
          <p class="inp9">版权所有：上海捷规建筑工程咨询有限公司</p>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  props: {
    title: {
      type: String,
      default: "123"
    },
    img: {
      type: String,
      default: "../assets/img/toplogo_jiegui.png"
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom {
  width: 100%;
  padding: 30px 0 0 0;
  background: #fdfdfd;
  border-top: 5px solid #A0131A;
  font-family: arial, "microsoft yahei" !important;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1.5;
  bottom: 0;
  color: #333;

  .ifoot_b {
    width: 1000px;
    margin: 0 auto;
  }
  
  .ifoot_b .ifoot_top {
    width: 100%;
    border-bottom: 1px solid #ddd;
    padding-bottom: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ifoot_b .ifoot_top .ifewm {
    width: 280px;
    margin-right: 110px;
  }
  .ifoot_b .ifoot_top .ifewm img {
    display: block;
    width: 100%;
  }
  .ifoot_b .ifoot_top .iftext {
    width: calc(100% - 200px);
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex-wrap: wrap;
  }

  .ifoot_b .ifoot_top .iftext p, .ifoot_b .ifoot_top .iftext p a, .ifoot_b .ifoot_top .iftext p span {
    font-size: 15px;
    line-height: 24px;
    color: #000;
  }
  .ifoot_b .ifoot_top .iftext p {
    float: left;
    width: 50%;
  }
}
 @media screen and (max-width: 700px) { /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
    .bottom .ifoot_b {
      width: 100%;
      margin: 0 auto;
    }
    
    .bottom .ifoot_b .ifoot_top .ifewm {
      width: 60%;
      margin: 0px auto;
    }
    .bottom .ifoot_b .ifoot_top .iftext {
      width: 100%;
      margin: 0px auto;
    }
    .bottom .ifoot_b .ifoot_top .iftext p[data-v-f0959a4a] {
      width: 100%;
      text-align: center;
    }
    .bottom .ifoot_b .ifoot_top[data-v-f0959a4a] {
     display: block;
    }
  }
  
  
</style>